import './InlineFieldLoader.css';
import React from 'react';

function InlineFieldLoader({ visible, label = 'Verifica in corso' }) {
  if (!visible) return null;

  return (
    <span className="iol-field-loader" role="status" aria-label={label}>
      <span className="iol-field-loader__ring" aria-hidden="true" />
    </span>
  );
}

export default InlineFieldLoader;
